import { createSelector } from 'reselect';

const wallets = state => state.wallet.userWallets;

export const walletContainsGBT = createSelector([wallets], wallets => {
    return wallets && wallets.filter(wallet => wallet.balances && wallet.balances.find(balance => balance.asset_code === 'GBT'));
});